import React, {Component} from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import cookie from 'react-cookie';
import { hashHistory } from 'react-router'
import Snackbar from 'material-ui/Snackbar';
import LogoImage from 'file-loader!../../images/Velox_Logo_Login.png'

const MuiTheme = getMuiTheme({
  palette: {
    primary1Color: '#23282D',
    accent1Color: '#07a6d1'
  },
  menu: {
    padding: 0
  }
});

const Styles = { 
  appContent: {
    width: '961px',
    margin: 'auto',
    backgroundColor: 'white',
    padding: '10px'
  }
};

class Login extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleTextFieldChanged = this.handleTextFieldChanged.bind(this);
    this.onSubmitLogin = this.onSubmitLogin.bind(this);
    this.handleErrorRequestClose = this.handleErrorRequestClose.bind(this);

    this.state = {
      username: '',
      password: '',
      errorMessageOpen: false,
      errorMessage: ''
    }    
  }

  handleTextFieldChanged(fieldName, e){
    var value = {};
    value[fieldName] = e.target.value
    this.setState(value);
  }

  onSubmitLogin(e){
    e.preventDefault();

    var utils = require('../../misc/utils');

    cookie.save('username', this.state.username, { path: '/' });

    var passwordBase64 = btoa(this.state.password);
    cookie.save('password', passwordBase64, { path: '/' });

    var context = this;
    utils.default.fetchCurrentUser((user) => {
      if(user)
        hashHistory.push('/');
      else    
        context.setState({errorMessageOpen: true, errorMessage: 'Utilisateur ou mot de passe invalide'});            
    });
  };

  handleErrorRequestClose(){
    this.setState({
      errorMessageOpen: false,
    });
  };  

  render() {
    return (
      <MuiThemeProvider muiTheme={MuiTheme}>
          <Paper style={Styles.appContent} zDepth={2}>
            <div style={{textAlign: 'center', padding: 50}}>
              <div><img src={LogoImage} style={{height: 100}}/></div>
              <form onSubmit={this.onSubmitLogin}>
                <div><TextField floatingLabelText='Utilisateur' value={this.state.username} onChange={(event) => this.handleTextFieldChanged('username', event)} /></div>
                <div><TextField type='password' floatingLabelText='Mot de passe' value={this.state.password} onChange={(event) => this.handleTextFieldChanged('password', event)} /></div>
                <div><FlatButton type='submit' style={{marginTop: 50}} label='Connexion' primary={true} /></div>
              </form>
              <Snackbar
                open={this.state.errorMessageOpen}
                message={this.state.errorMessage}
                onRequestClose={this.handleErrorRequestClose}
                autoHideDuration={4000}
              />        
            </div>
          </Paper>      
      </MuiThemeProvider>      
    )
  }
}

export default Login;


/** WEBPACK FOOTER **
 ** ./src/app/routes/general/login.js
 **/